export default {"src":"/_next/static/media/NYCB.16353675.svg","height":18,"width":18};